import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {DashboardQueryService} from '../../../shared/services/dashboard-query.service';
import {cloneDeep} from 'lodash';
import {SpiChartsService} from '../../../shared/services/spi-charts.service';
import {Equipe} from '../../../shared/models/equipe';
import {EquipesService} from '../../../shared/services/equipes.service';
import * as _ from 'lodash';
import {format} from 'date-fns';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;

  currentUser: any;

  selectedConfig: any = {
    rendererName: 'bar',
    cols: [], rows: [], vals: [],
    rowOrder: 'key_a_to_z', colOrder: 'key_a_to_z',
    showUI: true, usePivot: true, useDrill: false,
    table: { clickCallback: null, rowTotals: false, colTotals: false},
    localeStrings: { totals: 'Totals'}, filtersData:{},
    derivedAttributes: {},
    renderers: {},
    dataClassName: 'SubtotalPivotData',
    rendererOptions:
        { theme: 'macarons',
          title: {
            show: true,
            text: '', subtext: '', sublink: '', textStyle: { fontSize: 13, color: '#515253' },
            x: 'left'
          },
          legend: { show: true, bottom: 5, type: 'scroll'},
          grid: { left: 20, right: 20, top: 75, bottom: 50, containLabel: true},
          dataZoom: { show: true, start: 40, end: 100, bottom: 50, handleSize: 25},
          tooltip: { show: true },
          timeline: { axisType: 'category',  autoPlay: true, playInterval: 3000, data: []},
          collapseRowsAt: 1, collapseColsAt: 0,
          toolbox: {
            show: true,
            showTitle: true,
            feature: {
              mark: {show: true },
              dataZoom : {
                show: true,
                title: { zoom: 'area zooming', back:'restore area zooming'}
              },
              dataView: {
                show: false,
                readOnly: false,
                title: 'data view',
                lang: ['Data view','Close','Refresh']},
              magicType: {
                show: true, type: ['line','bar','stack'],
                title: {
                  line: 'for line charts', bar: 'for bar charts', stack: 'for stacked charts', tiled: 'for tiled charts'
                }
              },
              restore: { show: true, title: 'restore'},
              saveAsImage: {
                show: true,
                title: 'save as image',
                lang: [ 'Right-click to save as picture']}
            }
          }
        },
    aggregatorName: 'Sum'
  };

  dataArr: any;

  cols: string[] = [];
  rows: string[] = [];
  vals: string[] = [];
  newConfig: any;
  renderers: string[] = [];
  aggregators: any[] = [];

  configChart: any[] = [];

  @ViewChild('main') MyDOMElement0: ElementRef;



  @ViewChild('main1') MyDOMElement: ElementRef;
  chartOption: any = { };

  equipes: Equipe[] = [];
  selectedEquipesId: number;

  currentYear = new Date().getFullYear();
  realCurrentYear = new Date().getFullYear();
  typeView = 'equipe';
  selectedUser: any;

  constructor(private equipeService: EquipesService, private dashboardQueryService: DashboardQueryService, private spiChartsService: SpiChartsService) { }

  ngOnInit(): void {

    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.selectedUser = this.currentUser;

    this.selectedConfig.rows = ['status'];
    this.selectedConfig.cols = ['date'];
    this.selectedConfig.vals = [];
    this.selectedConfig.aggregatorName = 'Count';

    this.chartOption =  cloneDeep(this.spiChartsService.getDefaultConfig2AxisChart());
    this.chartOption.series = [
      {  name : $localize `RDV_A_REPLACER`, color: '#48a9fd', data: [], type: 'bar' , stack : 'status'},
      {  name : $localize `EN CHIFFRAGE`, color: '#FFC300', data: [], type: 'bar', stack : 'status' },
      {  name : $localize `ATTENTE SIGNATURE DEVIS`, color: '#90de03', data: [], type: 'bar', stack : 'status' },
      {  name : $localize `RAPPEL`, color: '#ecec3c', data: [], type: 'bar', stack : 'status'},
      {  name : $localize `RDV`, color: '#06ce06', data: [], type: 'bar', stack : 'status'},
      {  name : $localize `DÉBUT TRAVAUX`, color: '#6d6dff', data: [], type: 'bar', stack : 'status'},
      {  name : $localize `DEVIS SIGNE`, color: '#00FFFF', data: [], type: 'bar', stack : 'status'},
      {  name : $localize `REFUS`, color: '#FF0000', data: [], type: 'bar', stack : 'status'},
      {  name : $localize `RDV TEL`, color: '#ff17c5', data: [], type: 'bar', stack : 'status'},
      {  name : $localize `PAS INTERESSANT`, color: '#59afcc', data: [], type: 'bar', stack : 'status'},
      {  name : $localize `ENGAGE`, color: '#59afcc', data: [], type: 'bar', stack : 'status'},
    ];
    this.chartOption.yAxis = [
      { type: 'value' }
    ];
    this.chartOption.legend.data = [
        $localize `RDV_A_REPLACER`,
        $localize `RDV`,
        $localize `EN CHIFFRAGE`,
        $localize `DÉBUT TRAVAUX`,
        $localize `DEVIS SIGNE`,
        $localize `ATTENTE SIGNATURE DEVIS`,
        $localize `RAPPEL`,
        $localize `REFUS`,
        $localize `RDV TEL`,
        $localize `PAS INTERESSANT`,
        $localize `ENGAGE`
    ];
    this.chartOption.title.show = true;
    this.chartOption.toolbox.show = false;
    this.chartOption.title.text = $localize `Nombre de fiches par semaine par status`;
    this.chartOption.title.subtext   = '';


    if (this.currentUser.role === 'SUPER_ADMIN') {
      this.updateCharts();
      this.drawChart1();
      this.equipeService.findByPage(0, 1000)
          .subscribe((res: any) => {
            this.equipes = res.content;
          }, err => {
            console.log(err);
          });
    } else {
      this.equipeService.findByIds(this.currentUser.equipes)
          .subscribe((res: any) => {
            this.equipes = res;
            if (this.equipes && this.equipes.length > 0 ) {
              this.selectedEquipesId = this.equipes[0].id;
            }
            this.updateCharts();
            this.drawChart1();
          }, err => {
            console.log(err);
          });
    }

  }

  drawChart1() {
    setTimeout (() => {
      let parameters = [
        { key : 'year', value: this.currentYear}
      ];
      if (this.typeView === 'equipe') {
        parameters.push({ key : 'equipes', value: this.selectedEquipesId ? this.selectedEquipesId : this.currentUser.role === 'SUPER_ADMIN' ? 0 : -1}) ;
        parameters.push({ key : 'userId', value: 0});
      } else {
        parameters.push({ key : 'equipes', value: 0}) ;
        parameters.push({ key : 'userId', value: this.selectedUser ? this.selectedUser.id : 0});
      }
      this.dashboardQueryService.runQuery('NB_FICHE_PAR_STATUS_PAR_SEMAINE', parameters)
          .subscribe(res => {
            void import('echarts').then(
                echarts => {
                  const myChart = echarts.init(this.MyDOMElement.nativeElement, 'macarons');
                  // use configuration item and data specified to show chart
                  this.fillData(res);
                  myChart.setOption(this.chartOption);
                });
          }, err => {
            console.log(err);
          });
    }, 500);
  }

  fillData(data) {
    this.chartOption.series[0].data = [];
    this.chartOption.series[1].data = [];
    this.chartOption.series[2].data = [];
    this.chartOption.series[3].data = [];
    this.chartOption.series[4].data = [];
    this.chartOption.series[5].data = [];
    this.chartOption.series[6].data = [];
    this.chartOption.series[7].data = [];
    this.chartOption.series[8].data = [];
    this.chartOption.series[9].data = [];
    this.chartOption.series[10].data = [];
    this.chartOption.xAxis.data = [];
    for (let i = 0; i < data.length; i++) {
      let row = data[i];
      let status = JSON.parse(row.status.value);
      let obj = _.countBy(status);console.log(row.week);console.log(obj);
      //this.chartOption.series[0].data.push(row.total);
      if (obj['RDV_A_REPLACER']) {
        this.chartOption.series[0].data.push(obj['RDV_A_REPLACER']);
      } else {
        this.chartOption.series[0].data.push(0);
      }
      if (obj['EN_CHIFFRAGE']) {
        this.chartOption.series[1].data.push(obj['EN_CHIFFRAGE']);
      } else {
        this.chartOption.series[1].data.push(0);
      }
      if (obj['ATTENTE_SIGNATURE_DEVIS']) {
        this.chartOption.series[2].data.push(obj['ATTENTE_SIGNATURE_DEVIS']);
      } else {
        this.chartOption.series[2].data.push(0);
      }
      if (obj['RAPPEL']) {
        this.chartOption.series[3].data.push(obj['RAPPEL']);
      } else {
        this.chartOption.series[3].data.push(0);
      }
      if (obj['RDV']) {
        this.chartOption.series[4].data.push(obj['RDV']);
      } else {
        this.chartOption.series[4].data.push(0);
      }
      if (obj['DEBUT_TRAVAUX']) {
        this.chartOption.series[5].data.push(obj['DEBUT_TRAVAUX']);
      } else {
        this.chartOption.series[5].data.push(0);
      }
      if (obj['DEVIS_SIGNE']) {
        this.chartOption.series[6].data.push(obj['DEVIS_SIGNE']);
      } else {
        this.chartOption.series[6].data.push(0);
      }
      if (obj['REFUS']) {
        this.chartOption.series[7].data.push(obj['REFUS']);
      } else {
        this.chartOption.series[7].data.push(0);
      }
      if (obj['RDV_TEL']) {
        this.chartOption.series[8].data.push(obj['RDV_TEL']);
      } else {
        this.chartOption.series[8].data.push(0);
      }
      if (obj['PAS_INTERESSANT']) {
        this.chartOption.series[9].data.push(obj['PAS_INTERESSANT']);
      } else {
        this.chartOption.series[9].data.push(0);
      }
      if (obj['ENGAGE']) {
        this.chartOption.series[10].data.push(obj['ENGAGE']);
      } else {
        this.chartOption.series[10].data.push(0);
      }
      this.chartOption.xAxis.data.push('S' + row.week);
    }
  }

  updateCharts() {
    let parameters = [{ key : 'year', value: this.currentYear}];
    if (this.typeView === 'equipe') {
      parameters.push({ key : 'equipes', value: this.selectedEquipesId ? this.selectedEquipesId : this.currentUser.role === 'SUPER_ADMIN' ? 0 : -1}) ;
      parameters.push({ key : 'userId', value: 0});
    } else {
      parameters.push({ key : 'equipes', value: 0}) ;
      parameters.push({ key : 'userId', value: this.selectedUser ? this.selectedUser.id : 0});
    }
    this.blockUI.start();
    this.dashboardQueryService.runQuery('LIST_STATUS_PAT_SEMAINE_BRUT', parameters)
        .subscribe(res => {
          this.blockUI.stop();
          this.dataArr = res;
          this.drawChart();
        }, err => {
          this.blockUI.stop();
          console.log(err);
        });
  }

  drawChart() {
    let config =  cloneDeep(this.selectedConfig);
    config.rendererName = 'Table';
    config.useDrill = false;
    config.cols = ['semaine'];
    config.rows = ['qualification'];
    config.vals = [];
    config.aggregatorName = 'Count';
    this.configChart.push(config);
  }

  public reportConfig(e): void {
    this.newConfig = e;
  }

  loadDashboard() {
    this.drawChart1();
    this.updateCharts();
  }

  changeYear() {
    this.drawChart1();
    this.updateCharts();
  }

  onUserSelection(user: any) {
    if (user) {
      this.selectedUser = user;
    } else {
      this.selectedUser = this.currentUser;
    }
    this.loadDashboard();
  }
}
